/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonPlaceInfo,
    JsonPlaceInfoFromJSON,
    JsonPlaceInfoFromJSONTyped,
    JsonPlaceInfoToJSON,
} from './JsonPlaceInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonPlaceInfo
 */
export interface ApiResultOfListOfJsonPlaceInfo {
    /**
     * 
     * @type {Array<JsonPlaceInfo>}
     * @memberof ApiResultOfListOfJsonPlaceInfo
     */
    data?: Array<JsonPlaceInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonPlaceInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonPlaceInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonPlaceInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonPlaceInfo
     */
    result?: ApiResultOfListOfJsonPlaceInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonPlaceInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonPlaceInfoFromJSON(json: any): ApiResultOfListOfJsonPlaceInfo {
    return ApiResultOfListOfJsonPlaceInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonPlaceInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonPlaceInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonPlaceInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonPlaceInfoToJSON(value?: ApiResultOfListOfJsonPlaceInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonPlaceInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

